

















































































































import { computed, defineComponent, ref, watch, getCurrentInstance } from '@vue/composition-api';
import dayjs from 'dayjs';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { overCurrentTime } from '@/renderer/scripts/utils/dayjsUsage';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools';
import { httpUrl } from '@/renderer/scripts/http';
import ipc from '@/renderer/scripts/utils/ipc';
import store from '@/renderer/store';
import { RULE_LIST_MAP, RULE_LIST_VALUE_MAP } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import { getCustomDomainOrWebUrl } from '@/renderer/scripts/utils/CustomDomain/customDomain';

const initFileSubmitStatusdata = (): SMH.FileSubmitStatusData => ({
  submit: [],
  submitUserCount: 0,
  allowUserCount: 0,
});
export default defineComponent({
  name: 'fileCollectInfoDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    collectId: {
      type: Number,
      default: -1,
    },
  },
  setup(props, context) {
    const fileSubmitStatusdata = ref<SMH.FileSubmitStatusData>(initFileSubmitStatusdata());
    const fileCollectInfo = ref<SMH.fileCollectInfoData>({} as SMH.fileCollectInfoData);
    watch(
      () => props.show,
      val => {
        if (val) {
          methods.getFileSubmitStatus();
          methods.getLaunchedFileCollectionSetting();
        } else {
          fileSubmitStatusdata.value = initFileSubmitStatusdata();
        }
      },
    );
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const inviteUrl = computed(() => {
      const { code, domains } = fileCollectInfo.value;
      const domain = getCustomDomainOrWebUrl(domains);
      const url = i18n_t('链接：{slot1}/web/collect/{slot2}', {
        slot1: domain,
        slot2: encodeURIComponent(code as string),
      });
      return url;
    });
    const namingRulesString = computed(() => {
      const { namingRules = [] } = fileCollectInfo.value;
      if (namingRules.length === 0) return i18n_t('无');
      return namingRules.join('+');
    });
    const shareTitle = computed(() => {
      return i18n_t('{slot1}邀请您参与文件收集任务，点击链接开始提交你的文件吧。', {
        slot1: store.getters.userBaseInfo.nickname,
      });
    });
    const fileTypeString = computed(() => {
      const { fileType = [] } = fileCollectInfo.value;
      if (fileType.length === 0) return i18n_t('无');
      return fileType.join('、');
    });
    const timeString = computed(() => {
      const { isPermanent, expireTime } = fileCollectInfo.value;
      if (isPermanent) return i18n_t('永久有效');
      const vaildStr = isValid.value
        ? i18n_t('至 {slot1} 有效', {
            slot1: dayjs(expireTime).format(i18n_t('YYYY年MM月DD HH:mm:ss')),
          })
        : i18n_t('至 {slot1} 失效', {
            slot1: dayjs(expireTime).format(i18n_t('YYYY年MM月DD HH:mm:ss')),
          });
      return vaildStr;
    });
    const isValid = computed(() => {
      const { status, expireTime } = fileCollectInfo.value;
      return status === 1 && !overCurrentTime(new Date(), expireTime);
    });
    const isAssginPeople = computed(() => {
      const { allowedUsers = [] } = fileCollectInfo.value;
      if (allowedUsers.length === 0) return false;
      return true;
    });
    const methods = {
      async getFileSubmitStatus() {
        try {
          const { data } = await smh.userAPI.getFileSubmitStatus({
            collectId: props.collectId,
          });
          fileSubmitStatusdata.value = data;
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      async getLaunchedFileCollectionSetting() {
        try {
          const { data } = await smh.userAPI.getLaunchedFileCollectionSetting({
            collectId: props.collectId,
          });
          data.namingRules = data.namingRules
            ?.map(rule => RULE_LIST_VALUE_MAP[rule] || rule)
            .map(rule => RULE_LIST_MAP[rule] || rule);
          fileCollectInfo.value = data;
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      settingEvent() {
        innerShow.value = false;
        context.emit('settingEvent', props.collectId);
      },
      copyLink(link: string) {
        copyText2Clipboard(link)
          .then(() => {
            tips.success(i18n_t('分享链接已复制到剪贴板'));
          })
          .catch(() => {
            tips.error(i18n_t('分享链接复制出错'));
          });
      },
      async stopCollect() {
        try {
          await smh.userAPI.stopFileCollection({
            collectId: props.collectId,
          });
          tips.success(i18n_t('停止收集成功'));
          ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
          await methods.getLaunchedFileCollectionSetting();
          reporter.report('task_stop');
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      async restartCollect() {
        try {
          await smh.userAPI.restartFileCollection({
            collectId: props.collectId,
          });
          tips.success(i18n_t('已重新开启'));
          ipc.emit(ipc.RENDERER_EVENTS_MAP.COMMAND_REFRESH);
          await methods.getLaunchedFileCollectionSetting();
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
      async operationFileOrDir() {
        const { path, spaceId, spaceOrgId } = fileCollectInfo.value;
        const options = {
          path,
          spaceId,
          spaceOrgId,
        };
        const { data } = await smh.userAPI.getDirectoryOrFileInfo(options);
        innerShow.value = false;
        ipc.emit(ipc.RENDERER_EVENTS_MAP.DRAWER_DYNAMIC_OPEN, {
          ...data,
          toObjectPath: data.path.join('/'),
          spaceId,
          orgId: spaceOrgId,
        });
      },
    };
    return {
      settingEvent: methods.settingEvent,
      copyLink: methods.copyLink,
      stopCollect: methods.stopCollect,
      restartCollect: methods.restartCollect,
      operationFileOrDir: methods.operationFileOrDir,
      innerShow,
      fileSubmitStatusdata,
      fileCollectInfo,
      namingRulesString,
      fileTypeString,
      timeString,
      inviteUrl,
      shareTitle,
      overCurrentTime,
      isValid,
      isAssginPeople,
    };
  },
});
